'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002eshopping$0024package$0024$002dGrocery$002dItem$002dId$0024 from "./mealorama.shopping$package$-Grocery-Item-Id$.js";
var $p;
/** @constructor */
function $c_Lmealorama_StoreCartItem(id_$_lo, id_$_hi, storeCartId_$_lo, storeCartId_$_hi, groceryItemId, quantity, unit, pricePerUnit, comments, created, state) {
  this.jv = 0;
  this.jw = 0;
  this.pf = 0;
  this.pg = 0;
  this.k2 = null;
  this.mh = null;
  this.mi = null;
  this.ns = null;
  this.mg = null;
  this.nr = null;
  this.jc = null;
  this.am9 = null;
  this.ama = false;
  this.jv = id_$_lo;
  this.jw = id_$_hi;
  this.pf = storeCartId_$_lo;
  this.pg = storeCartId_$_hi;
  this.k2 = groceryItemId;
  this.mh = quantity;
  this.mi = unit;
  this.ns = pricePerUnit;
  this.mg = comments;
  this.nr = created;
  this.jc = state;
}
export { $c_Lmealorama_StoreCartItem as $c_Lmealorama_StoreCartItem };
$p = $c_Lmealorama_StoreCartItem.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_StoreCartItem;
/** @constructor */
function $h_Lmealorama_StoreCartItem() {
}
export { $h_Lmealorama_StoreCartItem as $h_Lmealorama_StoreCartItem };
$h_Lmealorama_StoreCartItem.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, 236917809, true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_StoreCartItem)) {
    var x_$_lo = this.jv;
    var x_$_hi = this.jw;
    var $x_7 = x$0;
    var x$1_$_lo = $x_7.jv;
    var x$1_$_hi = $x_7.jw;
    if ((((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0)) {
      var x$2_$_lo = this.pf;
      var x$2_$_hi = this.pg;
      var $x_8 = x$0;
      var x$3_$_lo = $x_8.pf;
      var x$3_$_hi = $x_8.pg;
      var $x_6 = (((x$2_$_lo ^ x$3_$_lo) | (x$2_$_hi ^ x$3_$_hi)) === 0);
    } else {
      var $x_6 = false;
    }
    if (($x_6 && (this.k2 === x$0.k2))) {
      var x$4 = this.mh;
      var x$2$1 = x$0.mh;
      var $x_5 = ((x$4 === null) ? (x$2$1 === null) : x$4.f(x$2$1));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$3$1 = this.mi;
      var x$4$1 = x$0.mi;
      var $x_4 = ((x$3$1 === null) ? (x$4$1 === null) : x$3$1.f(x$4$1));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$5 = this.ns;
      var x$6 = x$0.ns;
      var $x_3 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$7 = this.mg;
      var x$8 = x$0.mg;
      var $x_2 = ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$9 = this.nr;
      var x$10 = x$0.nr;
      var $x_1 = ((x$9 === null) ? (x$10 === null) : x$9.f(x$10));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$11 = this.jc;
      var x$12 = x$0.jc;
      return ((x$11 === null) ? (x$12 === null) : (x$11 === x$12));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 9;
});
$p.r = (function() {
  return "StoreCartItem";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bL(this.jv, this.jw);
      break;
    }
    case 1: {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bL(this.pf, this.pg);
      break;
    }
    case 2: {
      return this.k2;
      break;
    }
    case 3: {
      return this.mh;
      break;
    }
    case 4: {
      return this.mi;
      break;
    }
    case 5: {
      return this.ns;
      break;
    }
    case 6: {
      return this.mg;
      break;
    }
    case 7: {
      return this.nr;
      break;
    }
    case 8: {
      return this.jc;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
$p.hE = (function() {
  if ((!this.ama)) {
    this.am9 = ($j_mealorama$002eshopping$0024package$0024$002dGrocery$002dItem$002dId$0024.$m_Lmealorama_shopping$package$GroceryItemId$(), this.k2);
    this.ama = true;
  }
  return this.am9;
});
function $isArrayOf_Lmealorama_StoreCartItem(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jZ)));
}
export { $isArrayOf_Lmealorama_StoreCartItem as $isArrayOf_Lmealorama_StoreCartItem };
var $d_Lmealorama_StoreCartItem = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_StoreCartItem, "mealorama.StoreCartItem", ({
  jZ: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_StoreCartItem as $d_Lmealorama_StoreCartItem };
//# sourceMappingURL=mealorama.-Store-Cart-Item.js.map
